import {
  SetProfilePictureParams,
  UploadResponse,
} from '@pypestream/design-system';
import { normalizeFileName } from '.';

export type DataFileType = 'scriptFile' | 'configFile' | 'assetData' | 'logo';

type UploadFileProps = Omit<SetProfilePictureParams, 'file'> & {
  url: string;
  type: DataFileType;
  file: File | File[] | FileList | null;
};

export const uploadFile = ({
  url,
  file,
  type,
  load,
  error,
  progress,
  abort,
  onChange,
}: UploadFileProps): {
  abort: SetProfilePictureParams['abort'];
} => {
  const request = new XMLHttpRequest();
  request.withCredentials = true;
  const method = type === 'assetData' || type === 'logo' ? 'PUT' : 'POST';

  request.open(method, url);

  request.upload.onprogress = (e) =>
    progress?.(e.lengthComputable, e.loaded, e.total);

  const formData = new FormData();

  const filesArray: File[] = (
    file instanceof FileList
      ? Array.from(file)
      : Array.isArray(file)
        ? file
        : [file]
  ).flatMap((f) =>
    f
      ? [
          new File([f], normalizeFileName(f.name), {
            type: f.type,
            lastModified: f.lastModified,
          }),
        ]
      : []
  );

  filesArray.forEach((f) => {
    formData.append(type, f);
  });

  request.onload = () => {
    if (request.status >= 200 && request.status < 300) {
      load?.(request.responseText);

      const result: UploadResponse = JSON.parse(
        request.response
      ) as UploadResponse;

      onChange?.({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        data: result.data,
        files: filesArray,
      });
    } else {
      const errorText = JSON.parse(request.response).message;
      const errorMessage = errorText
        ? errorText
        : file
          ? 'Error uploading file'
          : 'Error deleting file';
      error?.(errorMessage);
    }
  };

  const body = file ? formData : undefined;

  request.send(body);

  return {
    abort: () => {
      request.abort();

      abort?.();
    },
  };
};
